/**
 * Menü ikonu + rengi GEN_MENU_DAB.MENU_ICON_URL'den gelir: 'fa-solid fa-coins #059669'.
 * '#' ile başlayan parça renk, kalanı ikon sınıfı (DevExtreme `icon` seçeneği 'fa-solid fa-x'
 * değerini <i class="dx-icon fa-solid fa-x"> olarak basar; FontAwesome 6.5 index.html'de yüklü).
 * Kolon boşken backend eski DevExtreme ikon adını ('inactivefolder', 'box'...) gönderir, aynen kalır.
 */
export interface MenuGorunum {
  ikon: string;
  renk?: string;
}

const RENK = /^#[0-9a-f]{3,8}$/i;
const IKON_SINIFI = /^[a-z][a-z0-9-]*$/i;

/** Kolonda eski/anlamsız değerler olabiliyor ('#'); geçersiz parçalar atılır. */
export function menuIkonCoz(icon: string | null | undefined): MenuGorunum {
  const parcalar = (icon ?? '').trim().split(/\s+/).filter(Boolean);
  const renk = parcalar.find((p) => RENK.test(p));
  return { ikon: parcalar.filter((p) => IKON_SINIFI.test(p)).join(' '), renk };
}

/** İkon çözülemezse backend'in eski varsayılanı (GenMenuDabBs). */
export function varsayilanIkon(menuType: unknown): string {
  const tur = String(menuType ?? '');
  return tur === 'Module' || tur === '1' ? 'inactivefolder' : tur === 'Branch' || tur === '2' ? 'box' : 'edit';
}

/** Renk verilmemiş modüller için sabit (hash) renk — tüm temalarda okunur 600 tonları. */
const YEDEK_RENKLER = ['#475569', '#0284c7', '#059669', '#7c3aed', '#ea580c', '#db2777', '#0d9488', '#4f46e5', '#b45309', '#2563eb'];

export function yedekRenk(anahtar: string | number | null | undefined): string {
  const s = String(anahtar ?? '');
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return YEDEK_RENKLER[Math.abs(h) % YEDEK_RENKLER.length];
}

/**
 * Alt öğe ikonları (A — türe göre): backend'in eski DevExtreme varsayılanları (GenMenuDabBs) FontAwesome'a
 * eşlenir. MENU_ICON_URL ile özel ikon verilmiş öğeler olduğu gibi kalır.
 *   box (dal) → klasör (açıkken SCSS açık klasör gösterir) · edit (form) → belge
 *   ordersbox (rapor) → yazıcı, grup rapor → katmanlar · dataarea → dashboard: pasta, sorgu: büyüteçli grafik
 */
export function turIkonu(ikon: string, formName?: string | null): string {
  const form = formName ?? '';
  switch (ikon) {
    case 'box': return 'fa-solid fa-folder';
    case 'edit': return 'fa-regular fa-file-lines';
    case 'ordersbox': return form.includes('GROUP_VIEWER') ? 'fa-solid fa-layer-group' : 'fa-solid fa-print';
    case 'dataarea': return form.includes('DASHBOARD_VIEWER') ? 'fa-solid fa-chart-pie' : 'fa-solid fa-magnifying-glass-chart';
    default: return ikon;
  }
}
